import { useSnowplow } from '@/domains/shared/analytics/snowplow/useSnowplow';

export const useUniversalBootstrap = (trackingReady: boolean) => {
  useSnowplow(trackingReady);
};
